import React from 'react';
import Heading from '../../common/heading/Heading';
import {
	ONBOARDING_COMPANY_INFORMATION_TITLE,
	ONBOARDING_COMPANY_INFORMATION,
} from '../../../constants/CompanyInformation';
import './CompanyInformation.scss';

const CompanyInformationContainer = () => {
	return (
		<div className="onboarding-company-information">
			<Heading>{ONBOARDING_COMPANY_INFORMATION_TITLE}</Heading>
			{ONBOARDING_COMPANY_INFORMATION.map((text, index) => (
				// eslint-disable-next-line react/no-danger
				<p key={index} dangerouslySetInnerHTML={{ __html: text }} />
			))}
		</div>
	);
};

export default CompanyInformationContainer;
